import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authApi } from '../lib/api';

export function MagicLink({
  onAuth,
}: {
  onAuth: (user: { id: string; email: string; role: string }) => void;
}) {
  const [search] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'ok' | 'error'>('loading');
  const [msg, setMsg] = useState<string>('');

  useEffect(() => {
    const token = search.get('token');
    if (!token) {
      setStatus('error');
      setMsg('Lien invalide.');
      return;
    }
    authApi
      .verifyMagic(token)
      .then((res) => {
        onAuth(res.user);
        setStatus('ok');
        setTimeout(() => navigate('/'), 1200);
      })
      .catch((err) => {
        setStatus('error');
        setMsg((err as Error).message === 'invalid_or_expired' ? 'Lien expiré ou déjà utilisé.' : 'Erreur de connexion.');
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className="container" style={{ maxWidth: 480 }}>
      <div className="card" style={{ textAlign: 'center' }}>
        <h2>Connexion</h2>
        {status === 'loading' && <p>Vérification du lien…</p>}
        {status === 'ok' && <div className="alert alert-success">Connecté. Redirection…</div>}
        {status === 'error' && <div className="alert alert-error">{msg}</div>}
      </div>
    </main>
  );
}
